<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 1714.4 218.1"
    preserveAspectRatio="xMidYMid meet"
    :class="['a-jpca-logo', `a-jpca-logo--${variation}`]"
    height="45"
    :aria-labelledby="titleId"
    role="img"
  >
    <title :id="titleId">{{ logoTitle }}</title>
    <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->
    <g>
      <g>
        <g>
          <g v-if="variation.startsWith('red')">
            <g>
              <path
                class="cls-2"
                d="M74.08,0v113.85h-.19c.11.4.19.8.19,1.23v38.28c0,2.55-2.07,4.63-4.63,4.63s-4.63-2.07-4.63-4.63v-38.28c0-.43.08-.84.19-1.23H0v80.11c0,13.34,10.82,24.16,24.16,24.16h99.84c13.34,0,24.16-10.82,24.16-24.16V0h-74.08Z"
              />
              <path
                class="cls-2"
                d="M365.01,109.06c-3.46,0-6.27-2.81-6.27-6.27v-1c0-3.46,2.81-6.27,6.27-6.27h62.5V.81h-87.58c-12.32,0-22.31,9.99-22.31,22.31v172.68c0,12.32,9.99,22.31,22.31,22.31h87.58v-109.06h-62.5Z"
              />
              <path
                class="cls-2"
                d="M291.55,0h-131.22v218.12h74.08v-88.66h57.14c7.42,0,13.43-6.01,13.43-13.43V13.43c0-7.42-6.01-13.43-13.43-13.43ZM247.64,82.61c0,7.12-5.78,12.9-12.9,12.9V29.64c7.13,0,12.9,5.78,12.9,12.9v40.07Z"
              />
              <path
                class="cls-1"
                d="M4,98.98V23.49C4,12.74,12.74,4,23.49,4h37.33v77.92c0,9.41-7.65,17.06-17.06,17.06H4Z"
              />
              <path
                class="cls-1"
                d="M64.12,0H23.49C10.52,0,0,10.52,0,23.49v78.79c0,.39.32.71.7.71h43.06c11.63,0,21.06-9.43,21.06-21.06V.7c0-.39-.32-.7-.71-.7M56.82,8v73.92c0,7.2-5.86,13.06-13.06,13.06H8.01V23.49c0-8.54,6.94-15.48,15.48-15.48h33.33Z"
              />
              <path
                class="cls-1"
                d="M444.98,91.66V21.94c0-9.97,8.11-18.09,18.09-18.09h39.03v72.06c0,8.69-7.07,15.75-15.75,15.75h-41.37Z"
              />
              <path
                class="cls-1"
                d="M505.95,0h-42.88c-12.12,0-21.94,9.82-21.94,21.94v73.57h45.22c10.83,0,19.6-8.78,19.6-19.6V0ZM498.24,7.71v68.2c0,6.56-5.34,11.89-11.9,11.89h-37.51V21.94c0-7.85,6.39-14.23,14.24-14.23h35.17Z"
              />
              <path
                class="cls-1"
                d="M248.2,214.12v-54.57c0-9.14,7.43-16.57,16.57-16.57h36.21v54.05c0,9.42-7.66,17.09-17.09,17.09h-35.69Z"
              />
              <path
                class="cls-1"
                d="M304.99,138.98h-40.21c-11.36,0-20.58,9.21-20.58,20.58v58.57h39.7c11.65,0,21.09-9.44,21.09-21.09v-58.05ZM296.98,146.98v50.05c0,7.22-5.87,13.09-13.09,13.09h-31.69v-50.57c0-6.93,5.64-12.57,12.57-12.57h32.21Z"
              />
            </g>
            <path
              class="cls-2"
              d="M714.36,159.7h-140.43v-30.47h140.43v30.47ZM565.13,214.36h-37.7L621.37,3.88h47.75l93.93,210.49h-38.33l-66.29-149.23-12.25-29.85h-2.51l-12.25,29.85-66.29,149.23Z"
            />
            <g>
              <path
                class="cls-2"
                d="M811.81,126.71h-7.54v-26.39h6.91c1.46-8.59,4.4-16.28,8.8-23.09,4.4-6.81,10.31-12.2,17.75-16.18,7.43-3.97,16.49-5.97,27.17-5.97,11.94,0,21.68,2.51,29.22,7.54,7.54,5.03,13.04,11.73,16.49,20.11,3.46,8.38,5.19,17.49,5.19,27.33v20.42h-33.62v-13.82c0-11.31-2.51-19.58-7.54-24.82-5.03-5.23-13.41-7.85-25.14-7.85-13.41,0-23.04,3.67-28.9,10.99-5.87,7.33-8.8,17.91-8.8,31.73M811.81,214.36h-33.93V58.22h31.1v44.3l2.83,1.57v110.27Z"
              />
              <path
                class="cls-2"
                d="M1012.56,217.5c-17.18,0-32.15-3.4-44.92-10.21-12.78-6.8-22.68-16.34-29.69-28.59-7.02-12.25-10.53-26.34-10.53-42.26s3.51-30.58,10.53-42.73c7.01-12.15,16.91-21.62,29.69-28.43,12.77-6.81,27.75-10.21,44.92-10.21,15.71,0,29.63,2.72,41.78,8.17,12.14,5.45,21.72,13.04,28.74,22.78,7.02,9.74,10.53,21.21,10.53,34.4v3.14h-33.62v-1.89c0-12.14-4.19-21.2-12.57-27.17-8.38-5.97-20.22-8.95-35.5-8.95-17.59,0-30.47,4.24-38.64,12.73-8.17,8.48-12.25,21.2-12.25,38.17s4.09,29.37,12.25,37.86c8.17,8.48,21.05,12.72,38.64,12.72,15.28,0,27.12-2.98,35.5-8.95,8.37-5.97,12.57-15.03,12.57-27.17v-2.2h33.62v3.46c0,12.99-3.51,24.4-10.53,34.24-7.02,9.85-16.6,17.49-28.74,22.94-12.15,5.44-26.08,8.17-41.78,8.17"
              />
              <path
                class="cls-2"
                d="M1282.64,214.36h-33.62v-84.82c0-15.71-3.66-26.96-11-33.77-7.33-6.8-19.16-10.21-35.5-10.21-12.36,0-22.2,2.15-29.53,6.44-7.33,4.29-12.62,10.37-15.86,18.22-3.25,7.85-4.87,17.33-4.87,28.43l-6.6.32,1.57-32.99h6.91c1.89-8.8,5.29-17.07,10.21-24.82,4.92-7.75,11.89-14.03,20.89-18.85,9-4.81,20.1-7.23,33.3-7.23,14.24,0,26.12,2.88,35.66,8.64,9.53,5.76,16.65,13.62,21.36,23.56,4.71,9.95,7.07,21.31,7.07,34.09v92.99ZM1152.26,214.36h-33.93V3.87h33.93v210.49Z"
              />
            </g>
            <path
              class="cls-2"
              d="M1348.89,214.36h-33.93V58.22h33.93v156.14ZM1348.89,40h-33.93V3.87h33.93v36.13Z"
            />
            <polygon
              class="cls-2"
              points="1478.07 214.36 1436.61 214.36 1363.72 58.22 1401.1 58.22 1456.71 181.38 1459.22 181.38 1514.83 58.22 1551.59 58.22 1478.07 214.36"
            />
            <path
              class="cls-2"
              d="M1633.7,217.5c-16.96,0-31.84-3.14-44.61-9.43-12.78-6.28-22.67-15.5-29.69-27.64-7.02-12.15-10.53-26.81-10.53-43.98s3.5-30.58,10.53-42.73c7.01-12.15,16.81-21.62,29.37-28.43,12.57-6.81,27.33-10.21,44.29-10.21s30.32,2.88,42.57,8.64c12.25,5.76,21.78,14.14,28.59,25.13,6.8,11,10.21,24.46,10.21,40.37,0,2.72-.11,5.29-.32,7.7-.21,2.41-.52,4.77-.94,7.07h-142.63v-18.85h120.32l-8.8,11.62c.21-2.09.32-4.13.32-6.12v-6.13c0-14.45-4.14-25.18-12.41-32.2-8.28-7.02-20.79-10.53-37.54-10.53-18.64,0-31.94,4.3-39.9,12.88-7.96,8.59-11.94,20.94-11.94,37.07v8.17c0,16.34,3.97,28.8,11.94,37.38,7.96,8.59,21.36,12.88,40.21,12.88,16.34,0,28.12-2.56,35.35-7.7,7.22-5.13,10.84-12.3,10.84-21.52v-2.51h33.93v2.83c0,11.1-3.41,20.89-10.21,29.37-6.81,8.48-16.13,15.08-27.96,19.79-11.83,4.71-25.5,7.07-41,7.07"
            />
          </g>
          <g v-else>
            <g>
              <path
                class="cls-1"
                d="M74.1,0v113.8h-.2c.1.4.2.8.2,1.2v38.3c0,2.6-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6v-38.3c0-.4,0-.8.2-1.2H0v80.1c0,13.3,10.8,24.2,24.2,24.2h99.8c13.3,0,24.2-10.8,24.2-24.2V0h-74.1Z"
              />
              <path
                class="cls-1"
                d="M365,109.1c-3.5,0-6.3-2.8-6.3-6.3v-1c0-3.5,2.8-6.3,6.3-6.3h62.5V.8h-87.6c-12.3,0-22.3,10-22.3,22.3v172.7c0,12.3,10,22.3,22.3,22.3h87.6v-109.1h-62.5Z"
              />
              <path
                class="cls-1"
                d="M291.5,0h-131.2v218.1h74.1v-88.7h57.1c7.4,0,13.4-6,13.4-13.4V13.4c0-7.4-6-13.4-13.4-13.4ZM247.6,82.6c0,7.1-5.8,12.9-12.9,12.9V29.6c7.1,0,12.9,5.8,12.9,12.9v40.1Z"
              />
              <path
                class="cls-1"
                d="M4,99V23.5C4,12.7,12.7,4,23.5,4h37.3v77.9c0,9.4-7.7,17.1-17.1,17.1,0,0-39.8,0-39.8,0Z"
              />
              <path
                class="cls-1"
                d="M64.1,0H23.5C10.5,0,0,10.5,0,23.5v78.8c0,.4.3.7.7.7h43.1c11.6,0,21.1-9.4,21.1-21.1V.7c0-.4-.3-.7-.7-.7M56.8,8v73.9c0,7.2-5.9,13.1-13.1,13.1H8V23.5c0-8.5,6.9-15.5,15.5-15.5h33.3Z"
              />
              <path
                class="cls-1"
                d="M445,91.7V21.9c0-10,8.1-18.1,18.1-18.1h39v72.1c0,8.7-7.1,15.8-15.8,15.8,0,0-41.4,0-41.4,0Z"
              />
              <path
                class="cls-1"
                d="M506,0h-42.9c-12.1,0-21.9,9.8-21.9,21.9v73.6h45.2c10.8,0,19.6-8.8,19.6-19.6V0ZM498.2,7.7v68.2c0,6.6-5.3,11.9-11.9,11.9h-37.5V21.9c0-7.9,6.4-14.2,14.2-14.2,0,0,35.2,0,35.2,0Z"
              />
              <path
                class="cls-1"
                d="M248.2,214.1v-54.6c0-9.1,7.4-16.6,16.6-16.6h36.2v54.1c0,9.4-7.7,17.1-17.1,17.1h-35.7,0Z"
              />
              <path
                class="cls-1"
                d="M305,139h-40.2c-11.4,0-20.6,9.2-20.6,20.6v58.6h39.7c11.6,0,21.1-9.4,21.1-21.1v-58.1h0ZM297,147v50.1c0,7.2-5.9,13.1-13.1,13.1h-31.7v-50.6c0-6.9,5.6-12.6,12.6-12.6h32.2Z"
              />
            </g>
            <path
              class="cls-1"
              d="M714.4,159.7h-140.4v-30.5h140.4v30.5ZM565.1,214.4h-37.7L621.4,3.9h47.8l93.9,210.5h-38.3l-66.3-149.2-12.2-29.8h-2.5l-12.2,29.8-66.3,149.2h0Z"
            />
            <g>
              <path
                class="cls-1"
                d="M811.8,126.7h-7.5v-26.4h6.9c1.5-8.6,4.4-16.3,8.8-23.1,4.4-6.8,10.3-12.2,17.8-16.2,7.4-4,16.5-6,27.2-6s21.7,2.5,29.2,7.5c7.5,5,13,11.7,16.5,20.1,3.5,8.4,5.2,17.5,5.2,27.3v20.4h-33.6v-13.8c0-11.3-2.5-19.6-7.5-24.8-5-5.2-13.4-7.8-25.1-7.8s-23,3.7-28.9,11c-5.9,7.3-8.8,17.9-8.8,31.7M811.8,214.4h-33.9V58.2h31.1v44.3l2.8,1.6v110.3Z"
              />
              <path
                class="cls-1"
                d="M1012.6,217.5c-17.2,0-32.2-3.4-44.9-10.2-12.8-6.8-22.7-16.3-29.7-28.6-7-12.2-10.5-26.3-10.5-42.3s3.5-30.6,10.5-42.7c7-12.2,16.9-21.6,29.7-28.4,12.8-6.8,27.8-10.2,44.9-10.2s29.6,2.7,41.8,8.2c12.1,5.4,21.7,13,28.7,22.8s10.5,21.2,10.5,34.4v3.1h-33.6v-1.9c0-12.1-4.2-21.2-12.6-27.2-8.4-6-20.2-8.9-35.5-8.9s-30.5,4.2-38.6,12.7c-8.2,8.5-12.2,21.2-12.2,38.2s4.1,29.4,12.2,37.9c8.2,8.5,21,12.7,38.6,12.7s27.1-3,35.5-8.9c8.4-6,12.6-15,12.6-27.2v-2.2h33.6v3.5c0,13-3.5,24.4-10.5,34.2-7,9.9-16.6,17.5-28.7,22.9-12.2,5.4-26.1,8.2-41.8,8.2"
              />
              <path
                class="cls-1"
                d="M1282.6,214.4h-33.6v-84.8c0-15.7-3.7-27-11-33.8-7.3-6.8-19.2-10.2-35.5-10.2s-22.2,2.2-29.5,6.4c-7.3,4.3-12.6,10.4-15.9,18.2-3.2,7.8-4.9,17.3-4.9,28.4l-6.6.3,1.6-33h6.9c1.9-8.8,5.3-17.1,10.2-24.8,4.9-7.8,11.9-14,20.9-18.8,9-4.8,20.1-7.2,33.3-7.2s26.1,2.9,35.7,8.6c9.5,5.8,16.7,13.6,21.4,23.6,4.7,9.9,7.1,21.3,7.1,34.1v93h0ZM1152.3,214.4h-33.9V3.9h33.9v210.5Z"
              />
            </g>
            <path
              class="cls-1"
              d="M1348.9,214.4h-33.9V58.2h33.9v156.1ZM1348.9,40h-33.9V3.9h33.9v36.1Z"
            />
            <polygon
              class="cls-1"
              points="1478.1 214.4 1436.6 214.4 1363.7 58.2 1401.1 58.2 1456.7 181.4 1459.2 181.4 1514.8 58.2 1551.6 58.2 1478.1 214.4"
            />
            <path
              class="cls-1"
              d="M1633.7,217.5c-17,0-31.8-3.1-44.6-9.4-12.8-6.3-22.7-15.5-29.7-27.6-7-12.1-10.5-26.8-10.5-44s3.5-30.6,10.5-42.7c7-12.2,16.8-21.6,29.4-28.4,12.6-6.8,27.3-10.2,44.3-10.2s30.3,2.9,42.6,8.6c12.2,5.8,21.8,14.1,28.6,25.1,6.8,11,10.2,24.5,10.2,40.4s-.1,5.3-.3,7.7-.5,4.8-.9,7.1h-142.6v-18.8h120.3l-8.8,11.6c.2-2.1.3-4.1.3-6.1v-6.1c0-14.4-4.1-25.2-12.4-32.2-8.3-7-20.8-10.5-37.5-10.5s-31.9,4.3-39.9,12.9c-8,8.6-11.9,20.9-11.9,37.1v8.2c0,16.3,4,28.8,11.9,37.4,8,8.6,21.4,12.9,40.2,12.9s28.1-2.6,35.3-7.7c7.2-5.1,10.8-12.3,10.8-21.5v-2.5h33.9v2.8c0,11.1-3.4,20.9-10.2,29.4-6.8,8.5-16.1,15.1-28,19.8s-25.5,7.1-41,7.1"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
import { useLocalization } from "@thegetty-private/getty-ui";
import { useId } from "vue";

export default {
  name: "JPCALogo",

  props: {
    /**
     * the image title
     */
    title: {
      type: [String, undefined],
      default: undefined
    },
    /**
     * the variation
     */
    variation: {
      type: String,
      default: "lightOnDark",
      validation: (value) =>
        ["lightOnDark", "darkOnLight", "redOnLight", "redOnDark"].includes(
          value
        )
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      /**
       * the unique id for the title (aria)
       */
      titleId: `jpcaLogo${useId()}`,
      /**
       * the Logo Title
       *
       * @returns {string}
       */
      logoTitle: this.title ? this.title : this.translate("a-jpca-logo.title")
    };
  }
};
</script>
<style lang="scss">
@import "./index.scss";
</style>
